<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <div class="table-page-search-wrapper">
        <a-form layout='inline' @keyup.enter.native='searchQuery'>
          <a-row :gutter="24">
            <a-col :md='8' :sm='8'>
              <a-form-item :label="'ProductType'">
                <a-select mode='multiple'
                          v-model='queryParam.appSsids'
                >
                  <a-select-option v-for='item in appList' :key='item.appssid'>
                    {{ item.appName }}
                  </a-select-option>
                </a-select>

              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item :label="'ProductName'">
                <a-input v-model="queryParam.productName"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
            </span>
            </a-col>
          </a-row>
        </a-form>

      </div>
      <a-row>
        <a-col :md="2" :sm="24">
          <a-button style="margin-bottom: 10px" type="primary" @click="addProduct">Add</a-button>
        </a-col>

      </a-row>
    </div>
    <div class="table-page-search-wrapper">
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        bordered>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">
            Edit Details
          </a>
<!--          <a @click="handleEditConfig(record)">-->
<!--            Edit dynamic fields-->
<!--          </a>-->
          <a @click="updateProduct(record)">
            Modify
          </a>
        </span>
      </a-table>
    </div>
    <v-modal
      v-model="visible"
      title="ProductDetail">
      <div style="padding: 20px;">
        <v-installment-product-item
          v-if="visible"
          :id="productId"
          @close="visible = false;"/>
      </div>
    </v-modal>
    <v-modal
      v-model="visibleConfig"
      title="ProductConfigurationDetail">
      <div style="padding: 20px;">
        <v-product-fee-config-list
          v-if="visibleConfig"
          :id="productId"
          @close="visibleConfig = false;"/>
      </div>
    </v-modal>
    <installment-product-modal ref="installmentProductModal" @ok="modalFormOk" ></installment-product-modal>
  </a-card>
</template>

<script>
import { getProductList } from '@/webpublicapi/installmentProductManager'
import Dict from '../modules/Dict'
import vModal from '../modules/Modal';
import vInstallmentProductItem from './InstallmentProductItemList.vue'
import vProductFeeConfigList from './ProductFeeConfigList.vue'
import InstallmentProductModal from './modules/InstallmentProductModal'
import {getApplist} from "@/webpublicapi/order";

export default {
  name: 'installmentProductManagement',
  components: { Dict, vModal, vInstallmentProductItem, InstallmentProductModal, vProductFeeConfigList },
  data () {
    return {
      visible: false,
      visibleConfig: false,
      dataSource: [],
      loading: false,
      productId: undefined,
      queryParam: {
        'appSsids': '',
        'type': '-2'
      },
      appList: [],
      // Table header
      columns: [
        {
          title: 'ProductName',
          align: 'left',
          dataIndex: 'productName',
          customRender: function (text, row, index) {
            return text + "-" + row.appssid;
          }
        },
        {
          title: 'Pre/Post Disbursement Receipt',
          align: 'left',
          dataIndex: 'receiptTimeFlag',
          customRender: function (text) {
            if (text==='0') {
              return "Pre-disbursement Receipt"
            } else {
              return "Post-disbursement Receipt"
            }
          }
        },
        {
          title: 'Status',
          align: 'left',
          dataIndex: 'status',
          customRender: function (text) {
            if (text==='1') {
              return "Valid"
            } else {
              return "Expired"
            }
          }
        },
        {
          title: 'ProductType',
          align: 'left',
          dataIndex: 'type',
          customRender: function (text) {
            if (text==='0') {
              return "Front-end Product"
            } else if (text==='-1') {
              return "On-package Product"
            } else if (text==='-2') {
              return "ASOProduct"
            }
          }
        },
        {
          title: 'Action',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created () {
    this.loadData()
    getApplist().then(res => {
      this.appList = res.data || [];
    })
  },
  methods: {
    loadData () {
      this.searchQuery();
    },
    handleEdit (record) {
      this.productId = record.id;
      this.appSsid = record.appSsid;
      this.visible = true;
    },
    handleEditConfig (record) {
      this.productId = record.id;
      this.appSsid = record.appSsid;
      this.visibleConfig = true;
    },
    addProduct() {
      this.$refs.installmentProductModal.add({"type":"-2"});
      this.$refs.installmentProductModal.title = 'AddProduct';
    },
    updateProduct(record) {
      record.googleFlag = '0';
      this.$refs.installmentProductModal.edit(record);
      this.$refs.installmentProductModal.title = 'EditProduct';
    },
    modalFormOk () {
      this.loadData();
    },
    searchQuery() {
      this.loading = true
      getProductList(Object.assign({}, this.queryParam)).then((res)=>{
        if(res.code===1000){
          this.dataSource = res.data
        }else{
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },
  }
}
</script>
<style lang="less" scoped>
 @import "~@/assets/less/common.less";
</style>
